import enTranslationProjects from "./en/translation-projects.json";
import enTranslationFilters from "./en/translation-filters.json";
import enTranslationWelcomePage from "./en/translation-welcome-page.json";
import enTranslationErrors from "./en/translation-errors.json";
import enTranslationSurveyDashboard from "./en/translation-survey-dashboard.json";
import enTranslationCommon from "./en/translation-common.json";
import enTranslationSurveyRespondentErrors from "./en/translation-survey-respondent-errors.json";
import enTranslationSurveys from "./en/translation-surveys.json";
import enTranslationManageUsers from "./en/translation-manage-users.json";
import enTranslationSurveyLinkStatus from "./en/translation-survey-link-status.json";
import enTranslationSurveyStatus from "./en/translation-survey-status.json";

export const eagleEnTranslation = {
  projects: enTranslationProjects,
  filters: enTranslationFilters,
  welcomePage: enTranslationWelcomePage,
  errors: enTranslationErrors,
  surveyDashboard: enTranslationSurveyDashboard,
  common: enTranslationCommon,
  surveyRespondentErrors: enTranslationSurveyRespondentErrors,
  surveys: enTranslationSurveys,
  manageUsers: enTranslationManageUsers,
  surveyLinkStatus: enTranslationSurveyLinkStatus,
  surveyStatus: enTranslationSurveyStatus,
};
